export default __webpack_public_path__ + "static/media/office1-before2-768w.d32ac3c1.png";